export enum CommentaryFormat {
  HTML = 'HTML',
  PDF = 'PDF',
}

export enum CommentaryTypeLabel {
  HYBRID = 'HYBRID',
  PAPER = 'PAPER',
  OPEN = 'OPEN',
  USER_GENERATED = 'USER_GENERATED',
}

export type CommentaryBase = {
  author?: string;
  date: string;
  niceSource: string;
  commentaryId: string;
  referenceCommentaryId: string;
  title: string;
  sourceName: string;
  textShort: string;
  url: string;
};

export type CommentaryWithFormat = CommentaryBase & {
  format: CommentaryFormat;
  typeLabel: CommentaryTypeLabel;
  dateHtml: string;
};

export interface PaperCommentary extends CommentaryWithFormat {
  typeLabel: CommentaryTypeLabel.PAPER;
}

export interface HybridCommentary extends CommentaryWithFormat {
  typeLabel: CommentaryTypeLabel.HYBRID;
}

export interface OpenCommentary extends CommentaryWithFormat {
  typeLabel: CommentaryTypeLabel.OPEN;
}

export interface UserCommentary extends CommentaryWithFormat {
  id: string;
  typeLabel: CommentaryTypeLabel.USER_GENERATED;
}

export type Commentary = PaperCommentary | HybridCommentary | OpenCommentary;
export type WebCommentary = OpenCommentary | UserCommentary;

export type CommentarySource = {
  docId: string;
  title: string;
  url: string;
  type: CommentarySourceType;
};

export type CommentaryDecisionSource = CommentarySource & {
  date: string;
};

export type CommentaryLegislationSource = CommentarySource & {
  startingDate: string;
  endingDate: string;
  occurrenceCount: number;
};

export enum CommentarySourceType {
  DECISION = 'decision',
  LEGISLATION = 'legislation',
}
